
export default function MapLocation() {
  return (
    <section className="relative py-16 sm:py-20 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">
            Trouvez-nous à Taza
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-400">
            Situés au cœur de la ville pour mieux vous servir
          </p>
        </div>

        <div className="relative backdrop-blur-xl bg-white/10 border border-white/20 rounded-3xl overflow-hidden shadow-2xl hover:shadow-[#fe7222]/20 transition-all duration-500">
          <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d3298.8305194067766!2d-3.9880627!3d34.2273456!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s!5e0!3m2!1sen!2sma!4v1767672545886!5m2!1sen!2sma"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="grayscale-[30%] contrast-125"
            ></iframe>
          </div>
        </div>

        {/* Info Section Below Map */}
        <div className="mt-8 backdrop-blur-xl bg-white/10 border border-white/20 rounded-2xl p-6 sm:p-8 shadow-xl">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center backdrop-blur-xl bg-[#fe7222]/20 border border-[#fe7222]/40 rounded-full flex-shrink-0">
                <i className="ri-map-pin-line text-lg text-[#fe7222]"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold mb-1">Adresse</h4>
                <p className="text-xs sm:text-sm text-gray-400">N 6, imm hassania, Taza 35000</p>
                <a href="https://maps.app.goo.gl/sVBkNY8jJEupxpHA6" target="_blank" rel="noopener noreferrer" className="text-xs text-[#fe7222] hover:underline mt-1 block">
                  Voir sur Google Maps
                </a>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center backdrop-blur-xl bg-[#fe7222]/20 border border-[#fe7222]/40 rounded-full flex-shrink-0">
                <i className="ri-phone-line text-lg text-[#fe7222]"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold mb-1">Téléphone</h4>
                <a href="tel:+212667304231" className="text-xs sm:text-sm text-gray-400 hover:text-[#fe7222] transition-colors cursor-pointer">
                  +212 667 304 231
                </a>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center backdrop-blur-xl bg-[#fe7222]/20 border border-[#fe7222]/40 rounded-full flex-shrink-0">
                <i className="ri-time-line text-lg text-[#fe7222]"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold mb-1">Horaires</h4>
                <p className="text-xs sm:text-sm text-gray-400">Lun - Dim: 8h - 20h</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center backdrop-blur-xl bg-[#fe7222]/20 border border-[#fe7222]/40 rounded-full flex-shrink-0">
                <i className="ri-whatsapp-line text-lg text-[#fe7222]"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold mb-1">WhatsApp</h4>
                <a href="https://wa.me/212667304231" target="_blank" rel="noopener noreferrer" className="text-xs sm:text-sm text-gray-400 hover:text-[#fe7222] transition-colors cursor-pointer">
                  Contactez-nous
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
